export const ENTERING_REFERAL_STEPS = [
  {
    desc: 'referral_steps_first_desc',
  },
  {
    desc: 'referral_steps_second_desc',
  },
  {
    desc: 'referral_steps_third_desc',
  },
];

export const REFERAL_FREQUENTLY_ASKED_QUESTIONS = [
  {
    id: '01',
    question: 'referral_first_faq_title',
    answer: ['referral_first_faq_description'],
  },
  {
    id: '02',
    question: 'referral_second_faq_title',
    answer: ['referral_second_faq_description'],
  },
  {
    id: '03',
    question: 'referral_third_faq_title',
    answer: ['referral_third_faq_description'],
  },
  {
    id: '04',
    question: 'referral_faq_fourth_title',
    answer: ['referral_faq_fourth_desc'],
  },
  {
    id: '05',
    question: 'referral_faq_fifth_title',
    answer: ['referral_faq_fifth_desc'],
  },
  {
    id: '06',
    question: 'referral_faq_sixth_title',
    answer: ['referral_faq_sixth_desc'],
  },
];
